module.exports = __webpack_public_path__ + "media/images/new_home/name-bg-21c28b2c2030bcdb0d5cdff53e9ebda1.png";